import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

/**
 * Returns MUI breakpoint "down" matches in a single hook call.
 * isSm = viewport is down('sm'), isMd = down('md'), etc.
 * Use this instead of multiple useMediaQuery(theme.breakpoints.down(...)) calls.
 */
export function useBreakpointsUp() {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  return useMemo(() => ({ isSm, isMd, isLg, isXl }), [isSm, isMd, isLg, isXl]);
}
